export default __webpack_public_path__ + "static/media/zelda.22130ade.png";